import React, { useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  TablePagination,
  Button,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useSelector } from "react-redux";
import ClearIcon from "@mui/icons-material/Clear";
import InputAdornment from "@mui/material/InputAdornment";
import MyEventCustomisationForm from "./MyEventCustomisationForm";
import TextField from "@mui/material/TextField";

const CustomisationSelector = ({ handleAddItems }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0); 
  const [selectedItems, setSelectedItems] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [searchQuery, setSearchQuery] = useState("");

  const eventCustomisations = useSelector((state) =>
    state?.eventcustomisations?.eventcustomisations?.filter(
      (item) => item?.maker !== "Content AI"
    )
  );
  const templates = useSelector((state) => state.template.template);

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => setPage(newPage);

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const toggleSelection = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSaveSelections = () => {
    handleAddItems(selectedItems);
    setModalOpen(false);
  };

  const dataToDisplay =
    selectedTab === 0
      ? eventCustomisations
      : selectedTab === 1
        ? templates
        : [];

  const contentAI = useSelector((state) => state?.dataToDisplay?.contentAI);
  const filteredData = dataToDisplay?.filter(
    (item) =>
      item?.eventCustomisationName
        ?.toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      item?.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredContentAI = contentAI?.filter((item) =>
    item?.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <Box display="flex" alignItems="center">
        <IconButton onClick={handleOpenModal} color="primary" size="large">
          <AddCircleOutlineIcon fontSize="large" />
        </IconButton>
        <Typography variant="h6" style={{ marginLeft: 8 }}>
          Select Content
        </Typography>
      </Box>

      <Dialog
        open={isModalOpen}
        onClose={handleCloseModal}
        fullWidth

        sx={{
          "& .MuiDialog-paper": {
            width: { xs: "95vw", md: "60vw" },
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
            padding: { xs: '2%', md: "unset" },
            maxWidth: "none",
            margin: "0px"
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            margin: { xs: "0.2rem", md: "1rem" },
          }}
        >
          <DialogTitle
            sx={(theme) => ({
              fontSize: {
                xs: "0.9rem",
                sm: "1.1rem",
                md: theme.typography.h6.fontSize,
              },
              paddingLeft: {
                xs: "2px",
                md: '24px'
              },
              paddingRight: {
                xs: "2px",
                md: '24px'
              },

            })}
          >
            Select Customizations
          </DialogTitle>

          <MyEventCustomisationForm />
        </Box>

      
        <Tabs value={selectedTab} onChange={handleTabChange} centered>
          <Tab
            sx={{
              paddingLeft: { xs: "8px", md: "16px" },
              paddingRight: { xs: "8px", md: "16px" }
            }}
            label="Content Library"
          />
          <Tab
          sx={{
              paddingLeft: { xs: "8px", md: "16px" },
              paddingRight: { xs: "8px", md: "16px" }
            }}
           label="Templates" 
           />
          <Tab 
          sx={{
              paddingLeft: { xs: "8px", md: "16px" },
              paddingRight: { xs: "8px", md: "16px" }
            }}
          label="Content AI" 
          />
        </Tabs>
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          p={2}
          sx={{ width: "100%" }}
        >
          <TextField
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search..."
            size="small"
            variant="standard"
            sx={{ maxWidth: 300 }}
            InputProps={{
              endAdornment: searchQuery && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setSearchQuery("")}
                    edge="end"
                  >
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <TableContainer style={{ flex: 1, overflowY: "auto" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Select</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>
                  {selectedTab === 0
                    ? "Event Customization Name"
                    : selectedTab === 1
                      ? "Template Name"
                      : "Content AI"}
                </TableCell>
                {selectedTab === 1 && <TableCell>Preview (HTML)</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedTab === 2
                ? filteredContentAI.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell
                      sx={{ cursor: "pointer" }}
                      onClick={() => toggleSelection(item.id)}
                    >
                      <Checkbox
                        checked={selectedItems.includes(item.id)}
                        onChange={() => toggleSelection(item.id)}
                        onClick={(e) => e.stopPropagation()} 
                        disableRipple
                      />
                    </TableCell>
                    <TableCell>
                      <img
                        src={item.imageUrl}
                        alt={item.name}
                        style={{
                          width: "150px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "4px",
                        }}
                      />
                    </TableCell>
                    <TableCell>{item.name}</TableCell>
                  </TableRow>
                ))
                : filteredData
                  ?.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                  ?.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell
                        sx={{ cursor: "pointer" }}
                        onClick={() => toggleSelection(item.id)}
                      >
                        <Checkbox
                          checked={selectedItems.includes(item.id)}
                          onChange={() => toggleSelection(item.id)}
                          onClick={(e) => e.stopPropagation()} 
                          disableRipple
                        />
                      </TableCell>
                      <TableCell>
                        {item?.customisations?.[0]?.imageUrl ? (
                          [".mp4", ".avi", ".mov"].some((ext) =>
                            item.customisations[0].imageUrl
                              .toLowerCase()
                              .endsWith(ext)
                          ) ? (
                            <video
                              src={item.customisations[0].imageUrl}
                              controls
                              style={{
                                width: "150px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          ) : (
                            <img
                              src={item.customisations[0].imageUrl}
                              alt={item.eventCustomisationName || item.name}
                              style={{
                                width: "150px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          )
                        ) : (
                          "No Media Available"
                        )}
                      </TableCell>
                      <TableCell>
                        {item.eventCustomisationName || item.name}
                      </TableCell>
                      {selectedTab === 1 && (
                        <TableCell>
                          <iframe
                            srcDoc={item.customProperties?.html || ""}
                            title={item.name}
                            style={{
                              width: "300px",
                              height: "200px",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                            }}
                          />
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box p={2}>
          <TablePagination
            rowsPerPageOptions={[6, 12, 24]}
            component="div"
            count={selectedTab === 2 ? contentAI.length : dataToDisplay.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        </Box>

   
        <Box display="flex" justifyContent="flex-end" p={2}>
          <Button
            onClick={handleCloseModal}
            variant="outlined"
            color="error"
            sx={{ mr: 2, textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveSelections}
            variant="contained"
            color="primary"
            sx={{ textTransform: "none" }}
          >
            Confirm
          </Button>
        </Box>
      </Dialog>
    </>
  );
};

export default CustomisationSelector;
